import { createValidationSchema, PosixDate, uuidField, } from "@for-it/domain-lib";
import { TenantEntity, TenantStatus, } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
/**
 * Soft delete: flips status to 'deleted'. A separate offline job is expected
 * to `DROP DATABASE tenant_<id>` after a grace period (see
 * docs/propuesta-multi-tenant-v2.md §6.2).
 */
export const deleteTenant = {
    name: "deleteTenant",
    description: "Soft-deletes a tenant by setting status to 'deleted'. Actual DB drop is handled by a separate job.",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        id: uuidField({
            required: true,
            message: "Debe ingresar un ID válido",
        }),
    }),
    useCase: async ({ db }, { id }) => {
        const tenant = await db.findOne(TenantEntity, { where: { id } });
        if (!tenant)
            return new TenantNotFoundError();
        const updated = {
            ...tenant,
            status: TenantStatus.DELETED,
            updatedAt: new PosixDate(Date.now()),
        };
        await db.save(TenantEntity, updated);
        return updated;
    },
};
